import { Drag, K1Blindness, K1View } from '@e3dc-react/icons'
import { CheckboxField } from '@e3dc-react/shell/Elements/InputFields'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Typography } from '@mui/material'
import React from 'react'
import { DASHBOARD_EDITOR_INSTRUCTIONS_PAGE_ID } from 'src/Libs/qa/ids'
import { makeStyles } from 'tss-react/mui'

interface InstructionPageProps {
  doNotShowAgain: boolean
  setDoNotShowAgain: (value: boolean) => void
}

const useStyles = makeStyles()(theme => ({
  instructionItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.shades.shade04,
    border: `1px solid ${theme.palette.shades.shade03}`,
    padding: theme.spacing(2),
  },
  instructionItemText: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
}))

/**
 * Instructions content for the dashboard editor
 */
const InstructionsContent: React.FC<InstructionPageProps> = ({ setDoNotShowAgain, doNotShowAgain }): React.ReactElement => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 2 }} data-qa={DASHBOARD_EDITOR_INSTRUCTIONS_PAGE_ID}>
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <Typography variant="h4">{t('dashboard.editor.instruction.title')}</Typography>
      </Box>
      <Box className={classes.instructionItem}>
        <Drag />
        <Box className={classes.instructionItemText}>
          <Typography variant="h3">{t('dashboard.editor.instruction.move.title')}</Typography>
          <Typography variant="body2">{t('dashboard.editor.instruction.move.text')}</Typography>
        </Box>
      </Box>
      <Box className={classes.instructionItem}>
        <K1View sx={{ color: 'primary.main' }} />
        <Box className={classes.instructionItemText}>
          <Typography variant="h3">{t('dashboard.editor.instruction.hide.title')}</Typography>
          <Typography variant="body2">{t('dashboard.editor.instruction.hide.text')}</Typography>
        </Box>
      </Box>
      <Box className={classes.instructionItem}>
        <K1Blindness sx={{ color: 'primary.main' }} />
        <Box className={classes.instructionItemText}>
          <Typography variant="h3">{t('dashboard.editor.instruction.show.title')}</Typography>
          <Typography variant="body2">{t('dashboard.editor.instruction.show.text')}</Typography>
        </Box>
      </Box>
      <Box>
        <CheckboxField label={t('dashboard.editor.instruction.do-not-show-again')} onChange={setDoNotShowAgain} value={doNotShowAgain} />
      </Box>
    </Box>
  )
}

export default InstructionsContent
